import { FC } from 'react';

import { getRequestedLanguages } from '../../locale/languages';
import { SizeClothingProduct } from '../../utils/models/product';

interface Props {
    sizes: SizeClothingProduct[];
    selectedSize: SizeClothingProduct | null;
    onSelectSize: (id: string) => void;
}

const SizeSelectorComponent: FC<Props> = ({ sizes, selectedSize, onSelectSize }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);

    return (
        <div className="br-sizeSelector">
            <p className="br-sizeSelector__label">{language.product.clothing_selector.size}</p>
            <div className="br-sizeSelector__list">
                {sizes.map((size) => {
                    return (
                        <div
                            key={`size-${size.label}-${size.id}`}
                            className={`br-sizeSelector__list--item ${selectedSize && size.id == selectedSize?.id && '-selected'} ${size?.quantity.max == 0 && '-disabled'}`}
                            onClick={() => {
                                onSelectSize(size.id);
                                // if (size.quantity.max == null) {
                                //     onSelectSize(size.id);
                                //     return;
                                // }
                                // if (size.quantity.max && size.quantity.max > 0) {
                                //     onSelectSize(size.id);
                                // }
                            }}
                        >
                            <p>{size.label}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SizeSelectorComponent;
